module.exports = __webpack_public_path__ + "img/filled-person.d9c1ce2f.svg";